import { useEffect, useCallback } from 'react';

/**
 * Custom hook for handling window resize events with debouncing
 * @param callback - Function to call when window is resized
 * @param delay - Debounce delay in milliseconds (default: 250ms)
 */
export const useWindowResize = (callback: () => void, delay: number = 250) => {
  const debouncedCallback = useCallback(() => {
    let timeoutId: NodeJS.Timeout;
    
    const debounced = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(callback, delay);
    };
    
    return debounced;
  }, [callback, delay]);

  useEffect(() => {
    const handleResize = debouncedCallback();
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [debouncedCallback]);
};
